/*
 * Scroll reveal
 *   - Auto-tags top-level ACF section wrappers with `.js-reveal`
 *   - IntersectionObserver adds `.is-revealed` when each enters the viewport
 *   - One-shot: observer disconnects per element after first reveal
 *   - Honours prefers-reduced-motion (CSS-side; JS still tags so animations
 *     can be re-enabled by toggling the media query).
 */

const SECTION_SELECTORS = [
    '.accommodation-options',
    '.booking-widget-section',
    '.card-grid',
    '.carousel',
    '.child-carousel',
    '.comparison',
    '.content-columns',
    '.content-illustration',
    '.cta',
    '.faqs',
    '.feature-tiles',
    '.features-grid',
    '.form-module',
    '.fullwidth-carousel',
    '.general-content',
    '.map-section',
    '.marquee',
    '.property-header',
    '.room-detail',
    '.statement',
    '.tiles',
    '.two-column-text',
].join(',');

export function initReveal() {
    const targets = document.querySelectorAll(SECTION_SELECTORS);
    if (!targets.length) return;

    targets.forEach((el) => el.classList.add('js-reveal'));

    if (!('IntersectionObserver' in window)) {
        targets.forEach((el) => el.classList.add('is-revealed'));
        return;
    }

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (!entry.isIntersecting) return;
                entry.target.classList.add('is-revealed');
                observer.unobserve(entry.target);
            });
        },
        {
            // Fire as soon as any part of the section crosses 10% above the
            // viewport bottom. A 0 threshold (rather than the previous 0.2)
            // means tall sections — common on mobile, where one section can
            // easily exceed viewport height — still trigger reliably.
            threshold: 0,
            rootMargin: '0px 0px -10% 0px',
        }
    );

    // Defer observe() across two animation frames so the browser paints the
    // initial opacity:0 / translateY state before the observer's first cycle
    // adds .is-revealed. Without this, sections already in the viewport on
    // load can skip the transition entirely (the engine collapses both
    // states into one frame).
    requestAnimationFrame(() => {
        requestAnimationFrame(() => {
            targets.forEach((el) => observer.observe(el));
        });
    });
}
